function Index() {

  return (
    <div className="showcard">  
          <div className="intro">
              <p>Your vehicle takes care of you every day on the road. It's important for<br></br>for you to keep up on your vehicles maintenance.</p>
              <img src="https://cdn.dealeraccelerate.com/stlouis/1/1595/50686/1920x1440/1969-dodge-charger" alt=""/>
              <p>This application is a great way for you to keep track of your vehicles needs.</p>
            
          </div>        
    </div>
 
  )
}

export default Index